module.exports = __webpack_public_path__ + "static/media/stak.f5991d3a.svg";